import { render, staticRenderFns } from "./loadingTela.vue?vue&type=template&id=0fba8542"
import script from "./loadingTela.vue?vue&type=script&lang=js"
export * from "./loadingTela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports